import React, { Component, useState, useEffect } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  CardFooter,
  Label,
  Row,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Badge,
  FormGroup,
  Input,
  CustomInput,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
// import TableScrollbar from "react-table-scrollbar";
import moment from "moment";
import Swal from "sweetalert2";

import "../MaterialRequest.scss";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";
import ChangeItem from "../ChangeItem";
import CustomProductRightbar from "./CustomProductRightbar";
import ProductHistory from "../ProductHistory";
import ItemDetails from "../../ItemDetails";
import ProductItemHistoryLog from "../../Material/ProductItemHistoryLog";

import {
  getUserDepartment,
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  getReqestRowDetails,
  MRitemHodApproval,
  MRHodApprovedRequest,
  AllMrHodItemsChecked,
  MrHODItemsChecked,
  ChangeItemModelOpen,
  getAllProducts,
  CPRightSidebar,
  GetProductHistory,
  productItemHistoryModelOpen,
} from "../../../store/MaterialRequest/actions";
import { MRCustomProduct } from "../../../store/Masters/Products/actions";
import LoadingModel from "../../LoadingModel";
import {
  getMiniQUALITY,
  getMiniProductQualities,
} from "../../../store/Mini/actions";

function PdfViewer({ url }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log("📥 PdfViewer: fetching via proxy, url:", url);
    setLoading(true);
    setError(null);

    fetch(url)
      .then((res) => {
        console.log("📥 fetch response status:", res.status);
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.blob();
      })
      .then((blob) => {
        console.log("✅ Blob received, size:", blob.size);
        const objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ PdfViewer fetch error:", err);
        setError(err.message);
        setLoading(false);
      });

    return () => {
      if (blobUrl) {
        URL.revokeObjectURL(blobUrl);
      }
    };
  }, [url]);

  if (loading) return <p style={{ padding: 10 }}>⏳ Loading PDF...</p>;
  if (error)
    return <p style={{ padding: 10, color: "red" }}>❌ Failed: {error}</p>;

  return (
    <iframe
      src={blobUrl}
      width="100%"
      height="600px"
      style={{ border: "none" }}
      title="PDF Document"
    />
  );
}

class MaterialRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      reqStateRowData: {},
      request_items: [],
      item_details: {},
      isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
      selectedOrderLocation: null,
      showImageModal: false,
      selectedQualities: {},
      showAddMore: {},
      itemQualities: {},
      currentItemLoading: null,
    };

    this.itemApprovedRequest.bind(this);
    this.tog_static = this.tog_static.bind(this);
    this.updateRequest = this.updateRequest.bind(this);
    this.CPRightbar = this.CPRightbar.bind(this);
  }
  tog_static(item) {
    this.setState((prevState) => ({
      modal_static: !prevState.modal_static,
      item_details: item,
    }));

    this.removeBodyCss();
  }

  toggleAddMore = (item) => {
    // Mark this item as loading
    this.setState({ currentItemLoading: item.id });

    // Load qualities for this item
    this.loadQualities(item);

    this.setState((prev) => ({
      showAddMore: {
        ...prev.showAddMore,
        [item.id]: !prev.showAddMore[item.id],
      },
    }));
  };

  handleAddMoreSelect = (item, values) => {
    const safeValues = values || [];
    const newQualities = safeValues.map((q) => ({
      id: q.value,
      name: q.label,
    }));
    this.setState((prev) => ({
      selectedQualities: {
        ...prev.selectedQualities,
        [item.id]: newQualities.map((q) => q.id),
      },
    }));
  };
  reject_Item_Model(item) {
    this.setState((prevState) => ({
      rejectItemModel: !prevState.rejectItemModel,
      rejectItem: item,
      rejectItemText: "",
      rejectErrorMsg: "",
    }));
    this.removeBodyCss();
  }
  reject_Model() {
    this.setState((prevState) => ({
      rejectModel: !prevState.rejectModel,
      rejectItemText: "",
      rejectErrorMsg: "",
    }));
  }

  removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  componentDidMount() {
    this.props.getUserDepartment(this.props.match.params.id);
    // this.props.getReqestRowDetails(
    //   this.props.match.params.id,
    //   this.props.userDeparment
    // );
  }

  ItemChangeHandeler(e, item) {
    this.props.ItemQtyChangeValue({
      key: e.target.name,
      value: e.target.value,
      item,
      status: "MaterialHod",
    });
  }

  itemApprovedRequest = (item, mrstatus) => {
    var data = {
      mrstatus: mrstatus,
      materialrequest_id: this.props.mrRowData.id,
      mritem_id: item.id,
      t_product_id: item.product.id,
      t_qty: item.t_qty == null ? item.qty : item.t_qty,
      t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
      t_make: item.t_make == null ? item.make : item.t_make,
      t_description:
        item.t_description == null ? item.description : item.t_description,
      t_quality_ids: this.state.selectedQualities[item.id] || [],
      description: this.state.rejectItemText,
    };
    if (mrstatus === 5) {
      Swal.fire({
        title: "Are you sure approve this item?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.MRitemHodApproval(data);
        }
      });
    }
    if (mrstatus === 6) {
      if (data.description !== "") {
        this.props.MRitemHodApproval(data);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }
  };

  handleQualitySelect = (itemId, qualityId) => {
    this.setState((prev) => {
      const current = prev.selectedQualities[itemId] || [];

      let updated;
      if (current.includes(qualityId)) {
        // remove if already selected (user unchecks)
        updated = current.filter((id) => id !== qualityId);
      } else {
        // add if newly selected
        updated = [...current, qualityId];
      }

      return {
        selectedQualities: {
          ...prev.selectedQualities,
          [itemId]: updated,
        },
      };
    });
  };

  updateRequest(mrstatus) {
    var mritems = [];
    this.props.mrCustomItem.map((item) => {
      if (item.mrstatus === 3 && item.itemcheck === true) {
        var ItemData = {
          mrstatus: mrstatus,
          materialrequest_id: this.props.mrRowData.id,
          mritem_id: item.id,
          t_product_id: item.product.id,
          t_qty: item.t_qty == null ? item.qty : item.t_qty,
          t_unit: item.t_unit == null ? item.unit.id : item.t_unit.id,
          t_make: item.t_make == null ? item.make : item.t_make,
          t_description:
            item.t_description == null ? item.description : item.t_description,
          description: this.state.rejectItemText,
          t_quality_ids: this.state.selectedQualities[item.id] || [],
        };
        mritems.push(ItemData);
      }
      return 0;
    });
    var data = {
      mrstatus: mrstatus,
      materialrequest_id: this.props.mrRowData.id,
      mrias: mritems,
      description: this.state.rejectItemText,
    };
    if (mrstatus === 5) {
      Swal.fire({
        title: "Are you sure approve this MR?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
      }).then((result) => {
        if (result.isConfirmed) {
          this.props.MRHodApprovedRequest(data, this.props.history);
        }
      });
    }
    if (mrstatus === 6) {
      if (data.description !== "") {
        this.props.MRHodApprovedRequest(data, this.props.history);
        this.setState({ rejectItemModel: false });
      } else {
        this.setState({ rejectErrorMsg: "this file is required" });
      }
    }

    // this.props.MRHodApprovedRequest(data, this.props.history);
  }

  loadQualities(item) {
    const { miniProductQualitiesParams } = this.props;

    // Dispatch saga action
    this.props.getMiniProductQualities({
      ...miniProductQualitiesParams,
      page: 1,
      page_size: 50,
      search: "",
      product: item.product?.id,
    });

    // Mark the current item being loaded
    this.setState({ currentItemLoading: item.id });
  }

  getAllCheckedRequest(e) {
    this.props.AllMrHodItemsChecked(e.target.checked);
  }
  getCheckedRequest(e, item, index) {
    this.props.MrHODItemsChecked(e.target.checked, item, index);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.miniProductQualitiesList !== this.props.miniProductQualitiesList
    ) {
      const { currentItemLoading, itemQualities } = this.state;

      if (currentItemLoading) {
        const rawResults = this.props.miniProductQualitiesList?.results || [];

        // ✅ Extract qualities from each item
        const allQualities = rawResults.flatMap((item) => item.qualities || []);

        // ✅ Convert final format for dropdown
        const mappedResults = allQualities.map((q) => ({
          ...q,
          label: q.name,
          value: q.id,
        }));

        this.setState({
          itemQualities: {
            ...itemQualities,
            [currentItemLoading]: mappedResults,
          },
          currentItemLoading: null,
        });
      }
    }
  }

  CPRightbar(item) {
    if (this.state.isMobile) {
      Swal.fire({
        icon: "error",
        title: "Please use the Desktop Version",
      });
    } else {
      this.props.CPRightSidebar(item);
      var cpItem = {
        baseunitLabel: item.product.baseunit.name,
        baseunit_id: item.product.baseunit.id,
        category: item.product.category,
        department: item.product.department,
        departmentLabel: item.product.department.name,
        department_id: item.product.department.id,
        group: item.product.group,
        image_path: item.product.image_path,
        image: item.product.image,
        name: item.product.name,
        section: item.product.section,
        tax: item.product.tax,
        units: item.product.units.map((unit) => {
          return {
            name: unit.name,
            units: unit.units,
          };
        }),
        vendors: item.product.vendors,
      };
      this.props.MRCustomProduct(cpItem);
    }
  }

  render() {
    // var UserDeptIds = this.props.userDeparment.map((dept) => dept.id);
    // var customItem = [];

    // if (this.props.mrRowData?.mritems) {
    //   customItem = this.props.mrRowData?.mritems?.filter((item) => {
    //     if (UserDeptIds.indexOf(item.department.id) === -1) {
    //       return false;
    //     }
    //     return true;
    //   });
    // }
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <AvForm className="needs-validation">
              <Row>
                <Col md={12}>
                  <Card>
                    <CardHeader className="bg-transparent border-bottom ">
                      <Link
                        to="/mrdashboard"
                        className="action-icon text-primary mr-2"
                      >
                        <i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
                      </Link>

                      <h5 className="card-title-18 pt-2 d-inline-block">
                        Material Request
                      </h5>
                      <div className="float-right">
                        <div className="d-inline-block ">
                          <Link
                            to={"/mrreportdoc/" + this.props.match.params.id}
                            className="action-icon text-primary mr-2"
                          >
                            <Button
                              type="button"
                              outline
                              color="secondary"
                              className=" mr-2"
                              // href={"/mrreportdoc/" + this.props.match.params.id}
                              // onClick={() => window.print()}
                            >
                              <i className="mdi  mdi-printer"></i>
                              <span className="d-none d-inline-block ml-1">
                                Print
                              </span>
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </CardHeader>
                    <CardBody className="pt-1 ">
                      <Row className="p-1">
                        <Col xl={4} className="p-1">
                          <Card className="p-1 bg-light">
                            <CardHeader
                              className="bg-transparent"
                              style={{
                                borderBottom: "1px solid #d9d9d9",
                              }}
                            >
                              <h3 className="card-title-15">
                                REQUEST DETAILS (
                                <span>
                                  <b>{this.props.mrRowData.code}</b>
                                </span>
                                )
                              </h3>
                            </CardHeader>
                            <CardBody className="pt-1 bg-light">
                              <Row className="p-0">
                                <Col md="12" className="p-1 m-0">
                                  <div className="Order-panel-content">
                                    <div className="list-column">
                                      <ul className="list-style-three p-0">
                                        <li className="clearfix">
                                          <span className="ttl">
                                            MR Issue status:
                                          </span>
                                          <span className="dtl">
                                            {this.props.mrRowData.mrstatus ===
                                              4 ||
                                            this.props.mrRowData.mrstatus ===
                                              6 ? (
                                              <>
                                                {this.props.mrRowData
                                                  .mrstatus === 4 && (
                                                  <span>HOD Rejected</span>
                                                )}
                                                {this.props.mrRowData
                                                  .mrstatus === 6 && (
                                                  <span>Admin Rejected</span>
                                                )}
                                              </>
                                            ) : (
                                              <>
                                                {
                                                  this.props.mrRowData
                                                    .mistatus_name
                                                }
                                              </>
                                            )}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            HOD(U) Approved by:
                                          </span>
                                          <span className="dtl">
                                            {this.props.mrRowData
                                              .userDeptApprovedby &&
                                              this.props.mrRowData
                                                .userDeptApprovedby[
                                                this.props.mrRowData
                                                  .userDeptApprovedby.length - 1
                                              ]?.approvedby.fullname}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            HOD(U) Approved Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.mrRowData
                                                .userDeptApprovedby &&
                                                this.props.mrRowData
                                                  .userDeptApprovedby[
                                                  this.props.mrRowData
                                                    .userDeptApprovedby.length -
                                                    1
                                                ]?.createdon,
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">Location:</span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.location
                                                ?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Sub Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.sublocation
                                                ?.name
                                            }
                                          </span>
                                        </li>

                                        <li className="clearfix">
                                          <span className="ttl">
                                            Order Location:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.orderlocation
                                                ?.name
                                            }

                                            {this.props.mrRowData.orderlocation
                                              ?.image && (
                                              <Button
                                                color="info"
                                                size="sm"
                                                className="ml-2"
                                                onClick={() =>
                                                  this.setState({
                                                    selectedOrderLocation:
                                                      this.props.mrRowData
                                                        .orderlocation,
                                                    showImageModal: true,
                                                  })
                                                }
                                              >
                                                View
                                              </Button>
                                            )}
                                          </span>
                                        </li>
                                        {/* <li className="clearfix">
                                          <span className="ttl">
                                            Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.department
                                                ?.name
                                            }
                                          </span>
                                        </li> */}
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Department:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData
                                                .userdepartment?.name
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            User Name:
                                          </span>
                                          <span className="dtl">
                                            {
                                              this.props.mrRowData.createdby
                                                ?.fullname
                                            }
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Submited Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.mrRowData.createdon,
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Required Date:
                                          </span>
                                          <span className="dtl">
                                            {moment(
                                              this.props.mrRowData.date,
                                            ).format("DD-MM-YYYY")}
                                          </span>
                                        </li>
                                        <li className="clearfix">
                                          <span className="ttl">
                                            Description:
                                          </span>
                                          <span className="dtl">
                                            {this.props.mrRowData.description}
                                          </span>
                                        </li>
                                        {this.props.mrRowData.mrstatus ===
                                          6 && (
                                          <li className="clearfix">
                                            <span className="ttl text-danger ">
                                              Reject Remark :
                                            </span>
                                            <span className="dtl">
                                              {
                                                this.props.mrRowData
                                                  .mr_approvals[
                                                  this.props.mrRowData
                                                    .mr_approvals.length - 1
                                                ].description
                                              }
                                            </span>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </Col>
                                {/* <Col md={12}>
                                  {this.props.mrRowData.mrstatus === 3 && (
                                    <>
                                      {this.props.mrPedningItems.length !==
                                      0 ? (
                                        <div className="text-center border-bottom">
                                          <Label className="font-size-24  text-primary">
                                            De
                                          </Label>
                                        </div>
                                      ) : (
                                        <div className="text-center border-bottom">
                                          <Label className="font-size-24  text-primary">
                                            Pending for other Departments
                                          </Label>
                                        </div>
                                      )}
                                    </>
                                  )}
                                  {(this.props.mrRowData.mrstatus === 5 ||
                                    this.props.mrRowData.mrstatus === 7 ||
                                    this.props.mrRowData.mrstatus === 8) && (
                                    <div className="text-center border-bottom">
                                      <Label className="font-size-24  text-success">
                                        Approved
                                      </Label>
                                    </div>
                                  )}
                                  {this.props.mrRowData.mrstatus === 6 && (
                                    <div className="text-center ">
                                      <Label className="font-size-24  text-danger">
                                        Rejected
                                      </Label>
                                    </div>
                                  )}
                                </Col> */}
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>
                        <Col md={12} xl={this.state.showImageModal ? 5 : 8}>
                          <Card className="p-1">
                            <CardBody className="pt-1">
                              <Row>
                                <Col md={12} className="mb-2">
                                  {!this.props.mrRowData.loading &&
                                    this.props.mrPedningItems.length !== 0 && (
                                      <div className="float-right text-center d-inline-blolck">
                                        <Button
                                          type="button"
                                          color="danger"
                                          size="sm"
                                          disabled={
                                            this.props.MRcheckedItem.length ===
                                            0
                                              ? true
                                              : false
                                          }
                                          className="waves-effect waves-light mr-2"
                                          onClick={() => this.reject_Model()}
                                        >
                                          {/* <i className="mdi mdi-thumb-down mr-2"></i>{" "} */}
                                          Reject Items (
                                          {this.props.MRcheckedItem.length})
                                        </Button>

                                        <Button
                                          type="button"
                                          className="waves-effect waves-light mr-2"
                                          color="success"
                                          size="sm"
                                          disabled={
                                            this.props.MRcheckedItem.length ===
                                            0
                                              ? true
                                              : false
                                          }
                                          onClick={() => {
                                            this.updateRequest(5);
                                          }}
                                        >
                                          {/* <i className="mdi mdi-thumb-up mr-2"></i> */}
                                          Approve Items (
                                          {this.props.MRcheckedItem.length})
                                        </Button>
                                      </div>
                                    )}
                                  <div className=" d-inline-blolck">
                                    <h3 className="card-title-15 ">
                                      Request Items List
                                    </h3>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="p-0">
                                <Col md={12} className="m-1">
                                  <div
                                    className="table-responsive m-0"
                                    style={{
                                      maxHeight: "400px",
                                      overflowY: "auto",
                                    }}
                                  >
                                    {/* <TableScrollbar height="400px"> */}
                                    <Table
                                      striped
                                      bordered
                                      hover
                                      className="mb-0 p-0 table-centered"
                                    >
                                      <thead className="bg-light text-center">
                                        <tr>
                                          <th
                                            style={{
                                              width: "20px",
                                            }}
                                          >
                                            {this.props.mrPedningItems
                                              .length !== 0 && (
                                              <CustomInput
                                                type="checkbox"
                                                name="itemCheckbox"
                                                id="MRitemscheck"
                                                checked={
                                                  this.props.allItemsCheked
                                                }
                                                onChange={(e) => {
                                                  this.getAllCheckedRequest(e);
                                                }}
                                              />
                                            )}
                                            {this.props.mrPedningItems
                                              .length === 0 && (
                                              <CustomInput
                                                type="checkbox"
                                                name="itemCheckbox"
                                                id="MRitemscheck"
                                                checked={true}
                                                disabled={true}
                                              />
                                            )}
                                          </th>
                                          <th className="nowrap">
                                            Item Images
                                          </th>
                                          <th
                                            style={{
                                              minWidth: "120px",
                                            }}
                                            className="nowrap"
                                          >
                                            Item Name
                                          </th>
                                          <th className="nowrap">Quantity</th>
                                          <th
                                            style={{
                                              minWidth: "180px",
                                            }}
                                          >
                                            Approved Qty gbiiii
                                          </th>
                                          <th className="nowrap">Item Issue</th>
                                          <th className="nowrap">Action</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {this.props.mrCustomItem.map(
                                          (item, key) => (
                                            <React.Fragment key={key}>
                                              <tr key={item.id}>
                                                <td className="nowrap text-center">
                                                  {item.mrstatus === 3 && (
                                                    <CustomInput
                                                      type="checkbox"
                                                      name="MRlistItem"
                                                      id={"mRitemscheck" + key}
                                                      checked={item.itemcheck}
                                                      disabled={
                                                        item.product.active ===
                                                        true
                                                          ? false
                                                          : true
                                                      }
                                                      onChange={(e) => {
                                                        this.getCheckedRequest(
                                                          e,
                                                          item,
                                                          key,
                                                        );
                                                      }}
                                                    />
                                                  )}
                                                  {item.mrstatus !== 3 && (
                                                    <CustomInput
                                                      type="checkbox"
                                                      name="MRlistItem"
                                                      id={"mRitemscheck" + key}
                                                      checked={true}
                                                      disabled={true}
                                                    />
                                                  )}
                                                </td>
                                                <td className="text-center">
                                                  <div className="product-detail text-center">
                                                    <img
                                                      src={
                                                        // item?.product?.image ==
                                                        // null
                                                        //   ? DefaultImg
                                                        //   : item?.product?.image
                                                        item?.mritemimages?.[0]
                                                          ?.image
                                                          ? item.mritemimages[0]
                                                              .image
                                                          : DefaultImg
                                                      }
                                                      alt="product-img"
                                                      title="product-img"
                                                      className="product-img  img-fluid mx-auto tab-img rounded"
                                                      style={{
                                                        height: "100px",
                                                        width: "150px",
                                                      }}
                                                    />
                                                  </div>
                                                  {/* <img
                                                  src={
                                                    item?.product?.image == null
                                                      ? DefaultImg
                                                      : item?.product?.image
                                                  }
                                                  alt="product-img"
                                                  title="product-img"
                                                  className="avatar-sm"
                                                /> */}
                                                </td>
                                                <td
                                                  style={{
                                                    minWidth: "220px",
                                                  }}
                                                >
                                                  <h5 className="font-size-14 ">
                                                    <Link
                                                      to="#"
                                                      onClick={() => {
                                                        this.tog_static(item);
                                                      }}
                                                      className="text-dark mr-2"
                                                    >
                                                      {item?.product?.name}
                                                    </Link>
                                                    {!item.product.active && (
                                                      <i className="text-danger ri-spam-line"></i>
                                                    )}
                                                    {item.mri_approvals
                                                      .length !== 0 && (
                                                      <>
                                                        <Link
                                                          to="#"
                                                          onClick={() => {
                                                            this.props.productItemHistoryModelOpen(
                                                              item.mri_approvals,
                                                            );
                                                          }}
                                                          className="text-dark"
                                                        >
                                                          <i className=" text-primary ri-eye-fill ml-2"></i>
                                                        </Link>
                                                      </>
                                                    )}
                                                    {item.mrstatus === 3 && (
                                                      <>
                                                        <>
                                                          <Link
                                                            to="#"
                                                            // onClick={this.CPRightbar}
                                                            onClick={() => {
                                                              this.props.ChangeItemModelOpen(
                                                                item,
                                                                "MRHod",
                                                              );
                                                              this.props.getAllProducts(
                                                                {
                                                                  ...this.props
                                                                    .params,
                                                                  search: "",
                                                                  page: 1,
                                                                },
                                                                true,
                                                              );
                                                            }}
                                                            className="ml-2 text-primary"
                                                          >
                                                            <i className="ri-pencil-line"></i>
                                                          </Link>
                                                          {item.product
                                                            .active ===
                                                            false && (
                                                            <Link
                                                              to="#"
                                                              onClick={() => {
                                                                this.CPRightbar(
                                                                  item,
                                                                );
                                                              }}
                                                              className="ml-2 text-primary"
                                                            >
                                                              <i className="ri-add-circle-line"></i>
                                                            </Link>
                                                          )}
                                                        </>
                                                      </>
                                                    )}
                                                    {item.product.active ===
                                                      true && (
                                                      <Link
                                                        to="#"
                                                        onClick={() => {
                                                          this.props.GetProductHistory(
                                                            item.product.id,
                                                          );
                                                        }}
                                                        className="ml-2 text-info"
                                                      >
                                                        <i className="ri-history-fill"></i>
                                                      </Link>
                                                    )}
                                                  </h5>

                                                  <p className="mb-0">
                                                    <b className="text-dark">
                                                      Make :
                                                    </b>{" "}
                                                    <span className="font-weight-medium">
                                                      {item.make}
                                                    </span>
                                                  </p>
                                                  <p className="mb-0">
                                                    <b className="text-dark">
                                                      Description :
                                                    </b>{" "}
                                                    <span className="font-weight-medium">
                                                      {item.description}
                                                    </span>
                                                  </p>
                                                  <p className="mb-0">
                                                    <b className="text-dark">
                                                      Item Info :
                                                    </b>{" "}
                                                    <span className="font-weight-medium">
                                                      {item.item_info}
                                                    </span>
                                                  </p>

                                                  {item.mrstatus === 6 && (
                                                    <p className="mb-0">
                                                      <b className="text-danger ">
                                                        Reject Remark :
                                                      </b>{" "}
                                                      <span>
                                                        {
                                                          item.mri_approvals[
                                                            item.mri_approvals
                                                              .length - 1
                                                          ].description
                                                        }
                                                      </span>
                                                    </p>
                                                  )}
                                                </td>
                                                <td className="text-center">
                                                  {item.mri_approvals.length ===
                                                  0
                                                    ? item.qty +
                                                      " " +
                                                      item.unit?.name
                                                    : item.mri_approvals[0]
                                                        .f_qty +
                                                      " " +
                                                      item.mri_approvals[0]
                                                        .f_unit.name}
                                                </td>

                                                <td
                                                  style={{
                                                    minWidth: "220px",
                                                  }}
                                                  className="nowrap text-center"
                                                >
                                                  {item.mrstatus === 3 ? (
                                                    <>
                                                      <FormGroup
                                                        row
                                                        className="mb-0"
                                                      >
                                                        <Col
                                                          xs={3}
                                                          sm={3}
                                                          md={3}
                                                        >
                                                          <Label
                                                            htmlFor="Qty"
                                                            className="col-form-label float-left"
                                                          >
                                                            Qty :
                                                          </Label>
                                                        </Col>
                                                        <Col
                                                          xs={9}
                                                          sm={9}
                                                          md={9}
                                                        >
                                                          <AvField
                                                            placeholder="Quantity"
                                                            className=" pr-0form-control"
                                                            min={0}
                                                            // max={100}
                                                            type="number"
                                                            // step="1"
                                                            name={key + "qty"}
                                                            id="qty"
                                                            value={item.qty}
                                                            validate={{
                                                              required: {
                                                                value: true,
                                                                errorMessage:
                                                                  "Please enter Qty",
                                                              },
                                                              pattern: {
                                                                value:
                                                                  "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
                                                                errorMessage:
                                                                  "Qty can compose numbers and 3 decimals ",
                                                              },
                                                            }}
                                                            onChange={(e) =>
                                                              this.ItemChangeHandeler(
                                                                e,
                                                                item,
                                                              )
                                                            }
                                                          />
                                                        </Col>
                                                      </FormGroup>
                                                      <FormGroup
                                                        row
                                                        className="mb-0"
                                                      >
                                                        <Col
                                                          xs={3}
                                                          sm={3}
                                                          md={3}
                                                        >
                                                          <Label
                                                            htmlFor="Units"
                                                            className="col-form-label float-left"
                                                          >
                                                            Units :
                                                          </Label>
                                                        </Col>
                                                        <Col
                                                          xs={9}
                                                          sm={9}
                                                          md={9}
                                                        >
                                                          <Select
                                                            id="units_select"
                                                            name="units_select"
                                                            required="required"
                                                            options={item?.product?.units?.map(
                                                              (i) => ({
                                                                label: i.name,
                                                                value: i.id,
                                                              }),
                                                            )}
                                                            value={{
                                                              label:
                                                                item.t_unit ==
                                                                null
                                                                  ? item?.unit
                                                                      ?.name
                                                                  : item.t_unit
                                                                      .name,

                                                              value:
                                                                item.t_unit ==
                                                                null
                                                                  ? item?.unit
                                                                      ?.id
                                                                  : item.t_unit
                                                                      .id,
                                                            }}
                                                            onChange={(e) => {
                                                              this.props.ItemUnitsChangeValue(
                                                                {
                                                                  label:
                                                                    e.label,
                                                                  value:
                                                                    e.value,
                                                                  item,
                                                                  status:
                                                                    "MaterialHod",
                                                                },
                                                              );
                                                            }}
                                                          />
                                                        </Col>
                                                      </FormGroup>
                                                    </>
                                                  ) : (
                                                    item.qty +
                                                    " " +
                                                    item.unit?.name
                                                  )}
                                                </td>
                                                <td className="text-center">
                                                  {item.mrstatus === 4 ||
                                                  item.mrstatus === 6 ? (
                                                    <>
                                                      {item.mrstatus === 4 && (
                                                        <span>
                                                          HOD Rejected
                                                        </span>
                                                      )}
                                                      {item.mrstatus === 6 && (
                                                        <span>
                                                          Admin Rejected
                                                        </span>
                                                      )}
                                                    </>
                                                  ) : (
                                                    <> {item.mistatus_name}</>
                                                  )}
                                                </td>

                                                <td className="nowrap text-center">
                                                  {item.mrstatus !== 1 &&
                                                    item.mrstatus !== 2 &&
                                                    item.mrstatus !== 3 && (
                                                      <Badge
                                                        className="font-size-14"
                                                        color={
                                                          item.mrstatus === 1 ||
                                                          item.mrstatus === 2 ||
                                                          item.mrstatus === 3
                                                            ? "primary"
                                                            : item.mrstatus ===
                                                                  5 ||
                                                                item.mrstatus ===
                                                                  7 ||
                                                                item.mrstatus ===
                                                                  8 ||
                                                                item.mrstatus ===
                                                                  11 ||
                                                                item.mrstatus ===
                                                                  12
                                                              ? "success"
                                                              : "danger"
                                                        }
                                                      >
                                                        {item.mrstatus_name}
                                                      </Badge>
                                                    )}
                                                  {/* {(item.mrstatus === 5 ||
                                                  item.mrstatus === 7 ||
                                                  item.mrstatus === 8) && (
                                                  <Badge
                                                    className="font-size-14"
                                                    color="success"
                                                  >
                                                    Admin Approved
                                                  </Badge>
                                                )}
                                                {item.mrstatus === 6 && (
                                                  <Badge
                                                    className="font-size-14"
                                                    color="danger"
                                                  >
                                                    Admin Rejected
                                                  </Badge>
                                                )}
                                                {item.mrstatus === 4 && (
                                                  <Badge
                                                    className="font-size-14"
                                                    color="danger"
                                                  >
                                                    HOD Rejected
                                                  </Badge>
                                                )} */}
                                                  {!this.props.mrRowData
                                                    .loading && (
                                                    <>
                                                      {item.mrstatus === 3 && (
                                                        <>
                                                          <Button
                                                            type="button"
                                                            color="success"
                                                            className="waves-effect waves-light mr-2"
                                                            disabled={
                                                              item.product
                                                                .active === true
                                                                ? false
                                                                : true
                                                            }
                                                            onClick={() => {
                                                              this.itemApprovedRequest(
                                                                item,
                                                                5,
                                                              );
                                                            }}
                                                          >
                                                            <i className="mdi mdi-check"></i>
                                                          </Button>
                                                          <Button
                                                            type="button"
                                                            color="danger"
                                                            className="waves-effect waves-light"
                                                            onClick={() =>
                                                              this.reject_Item_Model(
                                                                item,
                                                              )
                                                            }
                                                          >
                                                            <i className="mdi mdi-close"></i>
                                                          </Button>
                                                        </>
                                                      )}
                                                    </>
                                                  )}
                                                </td>
                                              </tr>

                                              <tr>
                                                <td colSpan="7" className="p-2">
                                                  <b>Qualities: </b>

                                                  {(() => {
                                                    const masterQualities =
                                                      this.state.itemQualities[
                                                        item.id
                                                      ] || [];
                                                    const existingQualities =
                                                      item?.qualities || [];

                                                    const mergedQualities = [
                                                      ...existingQualities,
                                                      ...masterQualities.filter(
                                                        (mq) =>
                                                          !existingQualities.some(
                                                            (eq) =>
                                                              eq.id === mq.id,
                                                          ),
                                                      ),
                                                    ];

                                                    // MR status flags (move here, outside map)
                                                    const isPending =
                                                      item.mrstatus === 1;
                                                    const isDeptApproved =
                                                      item.mrstatus === 3;
                                                    const isHodApproved =
                                                      item.mrstatus === 5;
                                                    const isRejected =
                                                      item.mrstatus === 4 ||
                                                      item.mrstatus === 6;

                                                    return (
                                                      <>
                                                        {mergedQualities.length >
                                                        0
                                                          ? mergedQualities.map(
                                                              (q) => {
                                                                const approvedQualities =
                                                                  item.mri_approvals
                                                                    ?.flatMap(
                                                                      (a) =>
                                                                        a.t_qualities ||
                                                                        [],
                                                                    )
                                                                    .map(
                                                                      (x) =>
                                                                        x.id,
                                                                    ) || [];

                                                                const isApproved =
                                                                  approvedQualities.includes(
                                                                    q.id,
                                                                  );
                                                                const isSelected =
                                                                  this.state.selectedQualities[
                                                                    item.id
                                                                  ]?.includes(
                                                                    q.id,
                                                                  ) || false;

                                                                // Determine if checkbox should be enabled
                                                                const canEdit =
                                                                  isPending ||
                                                                  isDeptApproved;

                                                                // Determine checked state
                                                                const isChecked =
                                                                  isPending
                                                                    ? isSelected
                                                                    : isDeptApproved
                                                                      ? isSelected ||
                                                                        isApproved
                                                                      : isHodApproved
                                                                        ? isApproved
                                                                        : false;

                                                                return (
                                                                  <label
                                                                    key={q.id}
                                                                    style={{
                                                                      marginRight:
                                                                        "15px",
                                                                    }}
                                                                  >
                                                                    <input
                                                                      type="checkbox"
                                                                      checked={
                                                                        isChecked
                                                                      }
                                                                      disabled={
                                                                        !canEdit &&
                                                                        !isRejected
                                                                      } // editable for MR1 and MR3
                                                                      onChange={
                                                                        canEdit
                                                                          ? () =>
                                                                              this.handleQualitySelect(
                                                                                item.id,
                                                                                q.id,
                                                                              )
                                                                          : undefined
                                                                      }
                                                                    />
                                                                    &nbsp;
                                                                    <span
                                                                      style={{
                                                                        color:
                                                                          isApproved
                                                                            ? "green"
                                                                            : isRejected
                                                                              ? "red"
                                                                              : "#000",
                                                                        fontWeight:
                                                                          isApproved
                                                                            ? "bold"
                                                                            : "normal",
                                                                      }}
                                                                    >
                                                                      {q.name}
                                                                    </span>
                                                                  </label>
                                                                );
                                                              },
                                                            )
                                                          : "-"}

                                                        {/* Add More button */}
                                                        {(isPending ||
                                                          isDeptApproved) && (
                                                          <button
                                                            className="btn btn-sm btn-primary ml-2"
                                                            onClick={() =>
                                                              this.toggleAddMore(
                                                                item,
                                                              )
                                                            }
                                                          >
                                                            Add More
                                                          </button>
                                                        )}

                                                        {/* Multi-select dropdown */}
                                                        {this.state.showAddMore[
                                                          item.id
                                                        ] && (
                                                          <div
                                                            style={{
                                                              width: "300px",
                                                              marginTop: "10px",
                                                            }}
                                                          >
                                                            <Select
                                                              isMulti
                                                              classNamePrefix="react-select"
                                                              options={masterQualities.map(
                                                                (q) => ({
                                                                  label: q.name,
                                                                  value: q.id,
                                                                }),
                                                              )}
                                                              value={(
                                                                this.state
                                                                  .selectedQualities[
                                                                  item.id
                                                                ] || []
                                                              ).map((id) => {
                                                                const q =
                                                                  masterQualities.find(
                                                                    (x) =>
                                                                      x.id ===
                                                                      id,
                                                                  );
                                                                return q
                                                                  ? {
                                                                      label:
                                                                        q.name,
                                                                      value:
                                                                        q.id,
                                                                    }
                                                                  : null;
                                                              })}
                                                              onChange={(
                                                                values,
                                                              ) =>
                                                                this.handleAddMoreSelect(
                                                                  item,
                                                                  values,
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                        )}
                                                      </>
                                                    );
                                                  })()}
                                                </td>
                                              </tr>
                                            </React.Fragment>
                                          ),
                                        )}
                                      </tbody>
                                    </Table>
                                    {/* </TableScrollbar> */}
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        </Col>

                        {this.state.showImageModal &&
                          (() => {
                            const loc = this.state.selectedOrderLocation;
                            return (
                              (loc?.send_flag1 && loc?.image) ||
                              (loc?.send_flag2 && loc?.image2) ||
                              (loc?.send_flag3 && loc?.image3)
                            );
                          })() && (
                            <Col md={12} xl={3}>
                              <Card className="p-1">
                                <CardHeader>
                                  <h5>Order Location Document:</h5>
                                  <Button
                                    color="secondary"
                                    size="sm"
                                    className="float-right"
                                    onClick={() =>
                                      this.setState({ showImageModal: false })
                                    }
                                  >
                                    Close
                                  </Button>
                                </CardHeader>
                                <CardBody className="p-0">
                                  {(() => {
                                    const loc =
                                      this.state.selectedOrderLocation;
                                    let activeImage = null;
                                    if (loc?.send_flag1 && loc?.image)
                                      activeImage = loc.image;
                                    else if (loc?.send_flag2 && loc?.image2)
                                      activeImage = loc.image2;
                                    else if (loc?.send_flag3 && loc?.image3)
                                      activeImage = loc.image3;

                                    if (!activeImage) {
                                      return (
                                        <p style={{ padding: 10 }}>
                                          No document available
                                        </p>
                                      );
                                    }

                                    let cleanUrl = activeImage.trim();
                                    try {
                                      const parsed = new URL(cleanUrl);
                                      cleanUrl =
                                        parsed.pathname + parsed.search;
                                    } catch (_) {}

                                    const isPdf = /\.pdf(\?.*)?$/i.test(
                                      cleanUrl,
                                    );

                                    return isPdf ? (
                                      <PdfViewer url={cleanUrl} />
                                    ) : (
                                      <img
                                        src={cleanUrl}
                                        alt="Order Location"
                                        style={{
                                          maxWidth: "100%",
                                          height: "auto",
                                        }}
                                      />
                                    );
                                  })()}
                                </CardBody>
                              </Card>
                            </Col>
                          )}
                      </Row>
                      <CardFooter className="bg-transparent pt-0">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/mrdashboard"
                          >
                            Cancel
                          </Button>
                          {/* {!this.props.mrRowData.loading &&
                            this.props.mrRowData.mrstatus !== 5 && (
                              <>
                                <Button
                                  type="submit"
                                  color="success"
                                  onClick={() => {
                                    this.updateRequest(5);
                                  }}
                                  className="waves-effect waves-light mr-2"
                                >
                                  Update & Approved
                                </Button>
                              </>
                            )} */}
                        </div>
                      </CardFooter>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </AvForm>
            {/* Change Item Model */}
            <ChangeItem />
            {/* CustomProductRightbar */}
            <CustomProductRightbar />
            {/* CustomProductRightbar end */}
            <ItemDetails
              modelOpen={this.state.modal_static}
              item={this.state.item_details}
              ItemLevel="MRLevel"
              modelClose={() => {
                this.setState({ modal_static: false });
              }}
            />
            <Modal
              isOpen={this.state.rejectItemModel}
              toggle={this.reject_Item_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader
                toggle={() => this.setState({ rejectItemModel: false })}
              >
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectItemModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      className="waves-effect waves-light d-inline-block"
                      onClick={() => {
                        this.itemApprovedRequest(this.state.rejectItem, 6);
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            <Modal
              isOpen={this.state.rejectModel}
              toggle={this.reject_Model}
              backdrop="static"
              centered
              // size="lg"
            >
              <ModalHeader toggle={() => this.setState({ rejectModel: false })}>
                Reject Remark
              </ModalHeader>
              <ModalBody className="pt-0">
                <Input
                  className="mb-0 form-control "
                  type="textarea"
                  step="1"
                  name="reject"
                  id="reject_item"
                  value={this.state.rejectItemText}
                  onChange={(e) =>
                    this.setState({
                      rejectItemText: e.target.value,
                    })
                  }
                  placeholder="Reject Description"
                />
                {this.state.rejectErrorMsg !== "" && (
                  <span className="text-danger mt-0">
                    {this.state.rejectErrorMsg}
                  </span>
                )}
                <div className="float-right mt-2">
                  <FormGroup>
                    <Button
                      type="button"
                      color="light "
                      className="waves-effect waves-light d-inline-block mr-2"
                      onClick={() =>
                        this.setState({
                          rejectModel: false,
                        })
                      }
                    >
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      color="primary"
                      className="waves-effect waves-light d-inline-block"
                      onClick={() => {
                        this.updateRequest(6);
                      }}
                    >
                      Submit
                    </Button>
                  </FormGroup>
                </div>
              </ModalBody>
            </Modal>
            <ProductItemHistoryLog />
            <ProductHistory />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const mapStatetoProps = (state) => {
  const {
    mrRowData,
    reqrowdata,
    mrCustomItem,
    mrPedningItems,
    MRcheckedItem,
    allItemsCheked,
    loading,
  } = state.Materialrequest;
  const {
    qualitylist,
    qualityParams,
    miniProductQualitiesList,
    miniProductQualitiesParams,
  } = state.Mini;

  return {
    mrRowData,
    reqrowdata,
    mrCustomItem,
    mrPedningItems,
    MRcheckedItem,
    allItemsCheked,
    loading,
    qualitylist,
    qualityParams,
    miniProductQualitiesList,
    miniProductQualitiesParams,
  };
};

export default connect(mapStatetoProps, {
  getUserDepartment,
  ItemQtyChangeValue,
  ItemUnitsChangeValue,
  getReqestRowDetails,
  MRitemHodApproval,
  MRHodApprovedRequest,
  AllMrHodItemsChecked,
  MrHODItemsChecked,
  ChangeItemModelOpen,
  getAllProducts,
  CPRightSidebar,
  MRCustomProduct,
  GetProductHistory,
  productItemHistoryModelOpen,
  getMiniQUALITY,
  getMiniProductQualities,
})(MaterialRequest);
